import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Pricing from "@/components/site/Pricing";
import WhyUs from "@/components/site/WhyUs";
import Reviews from "@/components/site/Reviews";
import Catering from "@/components/site/Catering";
import Gallery from "@/components/site/Gallery";
import Locations from "@/components/site/Locations";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

export default function Home() {
    return (
        <main data-testid="home-page" className="min-h-screen overflow-x-hidden">
            <Header />
            <Hero />
            <About />
            <Services />
            <Pricing />
            <WhyUs />
            <Reviews />
            <Catering />
            <Gallery />
            <Locations />
            <Contact />
            <Footer />
            <WhatsAppFab />
        </main>
    );
}
